import { supabase } from '../lib/supabase';
import type { Client, ClientInsert, ClientUpdate } from '../types/client';
import { createCrudService } from '../lib/createCrudService';

const crud = createCrudService<Client, ClientInsert, ClientUpdate>('clients', {
  orderBy: 'name',
  ascending: true,
});

export const clientService = {
  ...crud,

  async getByName(name: string): Promise<Client | null> {
    const { data, error } = await supabase
      .from('clients')
      .select('*')
      .ilike('name', name)
      .maybeSingle();

    if (error) throw error;
    return data;
  },

  async getCampaignCount(clientName: string): Promise<number> {
    const { count, error } = await supabase
      .from('campaigns')
      .select('*', { count: 'exact', head: true })
      .ilike('client', clientName);

    if (error) throw error;
    return count || 0;
  },
};
